"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const keys_1 = __importDefault(require("lodash/keys"));
exports.default = (values) => {
    if (values instanceof Array) {
        const returnValueMapping = (value) => {
            if ('const' in value) {
                return {
                    key: value.const,
                    value: value.title,
                    disabled: value.disabled || false,
                };
            }
            return Object.assign({}, value);
        };
        return values.map((e) => {
            const returnValue = typeof e === 'object' ? returnValueMapping(e) : { key: e, value: e };
            return returnValue;
        });
    }
    if (typeof values === 'object') {
        return keys_1.default(values).map((e) => ({ key: e, value: values[e] }));
    }
    return [];
};
//# sourceMappingURL=values-to-options.js.map